import { render, staticRenderFns } from "./PreferenceSales.vue?vue&type=template&id=48c75b4d&"
import script from "./PreferenceSales.vue?vue&type=script&lang=ts&"
export * from "./PreferenceSales.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('48c75b4d')) {
      api.createRecord('48c75b4d', component.options)
    } else {
      api.reload('48c75b4d', component.options)
    }
    module.hot.accept("./PreferenceSales.vue?vue&type=template&id=48c75b4d&", function () {
      api.rerender('48c75b4d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Preference/PreferenceSales.vue"
export default component.exports